/* Viva La Vulva — free Birth Comb with BIRTHGIFT  (v5)
 *
 * v5: Labour of Love + BIRTHGIFT = $9.95 off the kit (BIRTHGIFT-KIT) + free shipping
 * (BIRTHGIFT-SHIP), both applied here. FREE SHIPPING pill on photos of bundles in FREE_SHIP, award pill on kit page.
 *
 * Who qualifies: anyone who has BIRTHGIFT on their cart, who arrived from
 * a pop-up / email link carrying ?gift=birthgift, or who tapped the BIRTHGIFT
 * code box in the Klaviyo sign-up pop-up to copy it (remembered for 30 days).
 * When the rest of the cart is $65+, the Birth Comb is added and BIRTHGIFT is
 * applied to the cart, so the comb shows as FREE (struck-out $9.95).
 *
 * Safety: if Shopify doesn't actually make the comb $0, we take it back out,
 * so no one is ever charged $9.95 by surprise. If the cart drops below $65,
 * the auto-added comb is removed. If the customer removes it, we don't
 * re-add it for the rest of the visit. A comb the customer added themselves
 * is never touched (ours carries the hidden _free_gift line property).
 * Loaded from snippets/js-bridge.liquid (every page).
 */
(function () {
  var CODE = 'BIRTHGIFT';
  var COMB_VARIANT_ID = 44969199010089;
  var THRESHOLD_CENTS = 6500;
  var MARK_KEY = 'vlvGiftCode';
  var MARK_DAYS = 30;
  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  var KIT_VARIANT_ID = 47677694574889;
  var KIT_HANDLE = 'labour-of-love-kit-viva-la-vulva';
  var KIT_IMAGE = 'award-winning-postpartum-care1';
  var KIT_CODES = ['BIRTHGIFT-KIT', 'BIRTHGIFT-SHIP'];
  // Bundles priced over the $149 free-shipping line get a FREE SHIPPING pill: handle -> main photo file name
  var FREE_SHIP = {
    'labour-of-love-kit-viva-la-vulva': 'award-winning-postpartum-care1',
    'the-motherload-fourth-trimester-kit': 'VLV-RevivalKit-web'
  };
  var busy = false;
  var lastCart = null;

  function ls(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
  }
  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }

  function remember() { ls(MARK_KEY, JSON.stringify({ code: CODE, at: Date.now() })); }

  // Remember the gift if they arrived with ?gift=birthgift (or ?discount=BIRTHGIFT).
  (function rememberFromUrl() {
    var q = location.search.toLowerCase();
    if (q.indexOf('gift=birthgift') !== -1 || q.indexOf('discount=birthgift') !== -1) remember();
  })();

  function marked() {
    try {
      var m = JSON.parse(ls(MARK_KEY) || 'null');
      return !!(m && m.code === CODE && Date.now() - m.at < MARK_DAYS * 864e5);
    } catch (e) { return false; }
  }

  function codeOnCart(cart) {
    var codes = (cart.discount_codes || []).map(function (c) { return String(c.code || '').toUpperCase(); });
    if (codes.indexOf(CODE) !== -1) return true;
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return !!(m && decodeURIComponent(m[1]).toUpperCase().split(',').indexOf(CODE) !== -1);
  }

  // Without a cart round-trip: did they come via a BIRTHGIFT link / have the code cookie?
  function eligibleSync() {
    if (marked()) return true;
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return !!(m && decodeURIComponent(m[1]).toUpperCase().split(',').indexOf(CODE) !== -1);
  }

  function isOurComb(item) {
    return item.variant_id === COMB_VARIANT_ID && item.properties && item.properties._free_gift === CODE;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function post(url, body, withSections) {
    if (withSections) { body.sections = SECTIONS; body.sections_url = location.pathname; }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refreshCart() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    post('/cart/update.js', {}, true).then(function (data) {
      if (data && data.sections) {
        document.body.dispatchEvent(new CustomEvent('shapes:modalcart:cartqtychange', {
          bubbles: true, detail: { response: data }
        }));
      }
      try { if (window.Alpine && Alpine.store('cart_count')) Alpine.store('cart_count').count = data.item_count; } catch (e) {}
    });
  }
  window.vlvRefreshCart = refreshCart;

  function combLine(cart) {
    for (var i = 0; i < cart.items.length; i++) if (isOurComb(cart.items[i])) return cart.items[i];
    return null;
  }

  function check() {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var anyComb = false, otherTotal = 0;
      cart.items.forEach(function (item) {
        if (item.variant_id === COMB_VARIANT_ID) anyComb = true;
        else otherTotal += item.original_line_price;
      });
      var ours = combLine(cart);
      var kitInCart = cart.items.some(function (i) { return i.variant_id === KIT_VARIANT_ID; });
      var eligible = codeOnCart(cart) || marked();
      // Labour of Love already has the Birth Comb inside (priced in as free),
      // so kit orders never get a second comb.
      var qualifies = eligible && otherTotal >= THRESHOLD_CENTS && !kitInCart;
      lastCart = cart;
      decorate();

      // Labour of Love + BIRTHGIFT: the comb's price comes off the kit (BIRTHGIFT-KIT)
      // and shipping stays free (BIRTHGIFT-SHIP). Without the kit, those codes come off.
      var current = (cart.discount_codes || []).map(function (c) { return String(c.code).toUpperCase(); });
      var hasKitCodes = KIT_CODES.every(function (k) { return current.indexOf(k) !== -1; });
      if (kitInCart && eligible && !hasKitCodes) {
        var want = current.filter(function (c) { return c !== CODE && KIT_CODES.indexOf(c) === -1; }).concat(KIT_CODES);
        return post('/cart/update.js', { discount: want.join(',') }).then(getCart).then(function (c2) {
          lastCart = c2;
          if (!kitCodesOn(c2)) console.warn('[VLV] BIRTHGIFT-KIT did not apply');
          refreshCart();
        });
      }
      if (!kitInCart && current.some(function (c) { return KIT_CODES.indexOf(c) !== -1; })) {
        var keep = current.filter(function (c) { return KIT_CODES.indexOf(c) === -1; });
        if (eligible && keep.indexOf(CODE) === -1) keep.push(CODE);
        return post('/cart/update.js', { discount: keep.join(',') }).then(refreshCart);
      }

      if (ss('vlvCombAdded') === '1' && !anyComb && qualifies && !ours) {
        ss('vlvCombDeclined', '1');       // they took it out themselves
        ss('vlvCombAdded', '0');
        return;
      }

      if (qualifies && !anyComb && ss('vlvCombDeclined') !== '1') {
        return post('/cart/add.js', { items: [{ id: COMB_VARIANT_ID, quantity: 1, properties: { _free_gift: CODE } }] })
          .then(function () { return post('/cart/update.js', { discount: CODE }); })
          .then(getCart)
          .then(function (c2) {
            var line = combLine(c2);
            if (line && line.final_line_price > 0) {
              // Discount didn't make it free — don't charge them for it.
              console.warn('[VLV] BIRTHGIFT did not apply; removing comb');
              return post('/cart/change.js', { id: line.key, quantity: 0 }).then(refreshCart);
            }
            ss('vlvCombAdded', '1');
            refreshCart();
          });
      }

      // They already have a comb in the cart (added it themselves) and qualify:
      // just put BIRTHGIFT on the cart so that comb goes free.
      var codeListed = (cart.discount_codes || []).some(function (c) { return String(c.code || '').toUpperCase() === CODE; });
      if (qualifies && anyComb && !ours && !codeListed) {
        return post('/cart/update.js', { discount: ((cart.discount_codes || []).map(function (c) { return c.code; }).concat(CODE)).join(',') })
          .then(refreshCart);
      }

      if (ours && (!qualifies || ours.final_line_price > 0)) {
        return post('/cart/change.js', { id: ours.key, quantity: 0 }).then(function () {
          ss('vlvCombAdded', '0');
          refreshCart();
        });
      }
    })
    .catch(function (err) { console.warn('[VLV] free comb check failed:', err); })
    .finally(function () { setTimeout(function () { busy = false; }, 600); });
  }

  // Show "FREE" instead of "$0.00" on free cart lines (struck-out price stays).
  var ZERO = /\$0\.00(\s*NZD)?/;
  function labelFree() {
    var lines = document.querySelectorAll('li[data-cart-item-key]');
    Array.prototype.forEach.call(lines, function (li) {
      var walker = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, null), node;
      while ((node = walker.nextNode())) {
        if (ZERO.test(node.nodeValue) && !(node.parentNode && node.parentNode.closest('del, s'))) {
          node.nodeValue = node.nodeValue.replace(ZERO, 'FREE');
          if (node.parentNode) node.parentNode.style.fontWeight = '700';
        }
      }
    });
  }
  // ---- Labour of Love: FREE SHIPPING pill on photos, award pill under title, cart note
  var css = document.createElement('style');
  css.textContent =
    '.vlv-ship-pill{position:absolute;z-index:20;background:rgb(255,105,180);border:1px solid rgb(255,105,180);border-radius:14px;' +
    'color:#000;font-family:Lato,sans-serif;font-size:14px;line-height:16.8px;padding:7px;text-transform:uppercase;pointer-events:none;top:16px;right:16px}' +
    '.product-tile .vlv-ship-pill{top:0;right:0}' +
    '.vlv-kit-tag{display:inline-block;margin-top:.6rem;background:#F9D3E5;color:#5E444B;border-radius:999px;padding:.35rem .8rem;font-size:.875rem}' +
    '.vlv-kit-note{margin-top:.4rem;font-size:.8rem;line-height:1.5;color:#5E444B}' +
    '.vlv-kit-note div:before{content:"\\2713  ";color:#EC008C;font-weight:700}' +
    '.vlv-kit-note .vlv-hot{color:#EC008C}.vlv-kit-note .vlv-bold{font-weight:700}';
  (document.head || document.documentElement).appendChild(css);

  function pill(host) {
    if (!host || host.querySelector(':scope > .vlv-ship-pill')) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var b = document.createElement('span');
    b.className = 'vlv-ship-pill';
    b.textContent = 'Free shipping';
    host.appendChild(b);
  }

  function kitCodesOn(cart) {
    if (!cart) return false;
    return (cart.discount_codes || []).some(function (c) { return String(c.code).toUpperCase() === 'BIRTHGIFT-KIT' && c.applicable; });
  }

  function decorateKit() {
    // FREE SHIPPING pill on the kit's photos (product page + shop tiles), not on tiny cart thumbnails
    var sel = Object.keys(FREE_SHIP).map(function (h) { var k = FREE_SHIP[h]; return 'img[src*="' + k + '"], img[srcset*="' + k + '"]'; }).join(', ');
    var imgs = document.querySelectorAll(sel);
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.closest('li[data-cart-item-key], .vlv-ship-pill')) return;
      if (img.getBoundingClientRect().width < 140) return;
      var tile = img.closest('.product-tile');
      var host = tile ? (tile.querySelector('.pb-media-shadow') || img.parentElement)
                      : (img.closest('.media-content, .media-style-container, .media-shape-container') || img.parentElement);
      pill(host);
    });
    var tileSel = Object.keys(FREE_SHIP).map(function (h) { return '.product-tile a[href*="/products/' + h + '"]'; }).join(', ');
    Array.prototype.forEach.call(document.querySelectorAll(tileSel), function (a) {
      var tile = a.closest('.product-tile');
      if (!tile || tile.querySelector('.vlv-ship-pill')) return;
      var media = tile.querySelector('.pb-media-shadow, .media-content, .media-shape-container');
      if (media) pill(media);
    });
    // Award + shipping pill under the title on the kit's product page
    if (location.pathname.indexOf('/products/' + KIT_HANDLE) !== -1) {
      var h1 = document.querySelector('h1');
      if (h1 && !document.querySelector('.vlv-kit-title-tag')) {
        var tag = document.createElement('div');
        tag.className = 'vlv-kit-title-tag';
        tag.innerHTML = '<span class="vlv-kit-tag">2× OHbaby! Awards Gold · Free shipping</span>';
        h1.insertAdjacentElement('afterend', tag);
      }
    }
    // Cart line note
    Array.prototype.forEach.call(document.querySelectorAll('li[data-cart-item-key]'), function (li) {
      if (!li.querySelector('a[href*="/products/' + KIT_HANDLE + '"]')) return;
      var title = li.querySelector('[data-product-title]');
      var scored = lastCart ? kitCodesOn(lastCart) : false;
      var state = scored ? 'gift' : 'plain';
      var existing = li.querySelector('.vlv-kit-note');
      if (existing && existing.getAttribute('data-state') !== state) { existing.remove(); existing = null; }
      if (title && !existing) {
        var n = document.createElement('div');
        n.className = 'vlv-kit-note';
        n.setAttribute('data-state', state);
        if (scored) {
          var line = (lastCart.items || []).filter(function (i) { return i.variant_id === KIT_VARIANT_ID; })[0];
          var pay = line ? '<div class="vlv-bold">You pay $' + (line.final_line_price / 100).toFixed(2) + '</div>' : '';
          n.innerHTML = '<div class="vlv-hot vlv-bold">BIRTHGIFT: your Birth Comb comes off (−$9.95)</div>' +
            '<div>Free shipping still included</div>' + pay;
        } else {
          n.innerHTML = '<div>Free shipping on this kit</div>' +
            '<div class="vlv-hot">Got a BIRTHGIFT code? Pop it in below and your Birth Comb comes off the price.</div>';
        }
        var after = title.closest('a') || title;
        after.parentNode.insertBefore(n, after.nextSibling);
      }
    });
  }

  function decorate() { labelFree(); decorateKit(); }

  var labelTimer;
  new MutationObserver(function () {
    clearTimeout(labelTimer);
    labelTimer = setTimeout(decorate, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', decorate);

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(check, 300); }
  window.vlvCombCheck = schedule;

  // ---- Klaviyo pop-up: tapping the BIRTHGIFT code box to copy it counts as claiming the gift.
  // We remember it, put BIRTHGIFT on their visit, and the comb is added once the cart reaches $65.
  function claimFromCopy() {
    if (marked() && eligibleSync()) return;
    remember();
    fetch('/discount/' + CODE, { credentials: 'same-origin', redirect: 'follow' })
      .catch(function () {})
      .then(function () { return post('/cart/update.js', { discount: CODE }); })
      .catch(function () {})
      .then(schedule);
  }
  function inKlaviyoForm(el) {
    return !!(el && el.closest && el.closest('.klaviyo-form, [class*="klaviyo-form"], [data-testid*="klaviyo-form"], .needsclick.kl-private-reset-css-Xuajs1'));
  }
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!inKlaviyoForm(el)) return;
    for (var i = 0, n = el; i < 5 && n; i++, n = n.parentElement) {
      var t = (n.textContent || '').trim().toUpperCase();
      if (t.length && t.length < 40 && t.indexOf(CODE) !== -1) { claimFromCopy(); return; }
    }
  }, true);
  document.addEventListener('copy', function () {
    var sel = String(window.getSelection ? window.getSelection() : '').toUpperCase();
    if (sel.indexOf(CODE) !== -1 && inKlaviyoForm(document.activeElement)) claimFromCopy();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { decorate(); schedule(); });
  } else { decorate(); schedule(); }
  window.addEventListener('shapes:modalcart:afteradditem', schedule);
  window.addEventListener('shapes:modalcart:cartqtychange', function () {
    // our own refresh fires this too; only re-check when not mid-change
    if (!busy) schedule();
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-cart-item-key], [name="add"], button[type="submit"]')) schedule();
  });
})();
